module.exports = __webpack_public_path__ + "img/logo-bbb.544785d.png";